import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseResponse } from 'src/app/model/response/base-response';
import { environment } from 'src/environments/environment';
import { LockServerRequest } from './dynamicForm.interface';

@Injectable({
  providedIn: 'root'
})

export class DynamicformApiService {

  private url: string = `${environment.apiUrl}/lock/`;

  private isFormDirty = false;

  constructor(private http: HttpClient) { }

  checkLock(tableName: string, id: string, currentSession: string): Observable<BaseResponse> {
    let request: LockServerRequest = {
      tableName: tableName,
      id: id,
      session: currentSession
    }
    return this.http.post<BaseResponse>(`${this.url}check`, request);
  }

  setLock(tableName: string, id: string, currentSession: string): Observable<BaseResponse> {
    let request: LockServerRequest = {
      tableName: tableName,
      id: id,
      session: currentSession
    }
    return this.http.put<BaseResponse>(`${this.url}set`, request);
  }

  reSetLock(tableName: string, id:  string, currentSession: string): Observable<BaseResponse> {
    let request: LockServerRequest = {
      tableName: tableName,
      id: id,
      session: currentSession
    }
    return this.http.put<BaseResponse>(`${this.url}reset`, request);
  }


  setDirty(value: boolean) {
    this.isFormDirty = value;
  }

  getDirty(): boolean {
    return this.isFormDirty;
  }

  reset() {
    this.isFormDirty = false;
  }
}
